<template>
  <Modal name="DELETE_CATEGORY_MODAL" :title="title" actions>
    <template v-slot:body>
      <p>{{ $t('category.hints.delete') }}</p>
      <v-card class="pa-5 mt-5 grey lighten-3" outlined>
        <v-progress-linear v-if="isCategoryLoading" indeterminate />
        <span v-else>
          {{ category ? category.name : '---' }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isCategoryLoading"
        class="mr-5"
        large
        text
      >
        {{ $t('category.action.cancel') }}
      </v-btn>

      <v-btn
        @click="removeCategory(category.id)"
        :loading="isCategoryLoading"
        class="red"
        large
        dark
        text
      >
        {{ $t('category.action.delete') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'CategoryDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['category', 'isCategoryLoading']),
  },

  data() {
    return {
      title: this.$t('category.action.delete'),
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['removeCategory']),
  },
}
</script>
